<div class="soc-media-input__box">
  <input
    type="text"
    placeholder="{{ placeholder }}"
    class="soc-media-input"
    [value]="socContact.link"
    (input)="changeInputValueHandler($event)"
    (blur)="blurHandler()"
  />
  @if (!!link || !!socContact.link) {
    <div class="btv-icon-close" (click)="deleteHandler(socContact.type)"></div>
  }
</div>
